import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";
import union from "../assets/union.png";
import paypal from "../assets/paypal.png";
import stripe from "../assets/stripe.png";
import union1 from "../assets/union1.png";
import union3 from "../assets/union3.png";
import union4 from "../assets/union4.png";

import { useSelector } from "react-redux";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { kFormatter } from "../helper";
import callApi from "../../../../utils/apiCaller";
gsap.registerPlugin(ScrollTrigger);

const Slide2 = () => {
	const { yearEndData } = useSelector((state) => state.commonSetting);
	const formated = (value) => {
		let number = Number(value);
		if (number) {
			return kFormatter(number);
		} else return "0";
	};

	const handleClickReview = () => {
		let paramsClick = {
			action: "clickReview",
			type: "click_year_end",
			note: "click_fix_stripe",
		};
		callApi("get", paramsClick).then(async (res) => {
			// console.log(123, res);
		});
	};

	useEffect(() => {
		const scroll = {
			scroller: ".st-year-end-slides-scroll",
			trigger: ".year-wrap-slide-2",
			// markers: true,
			start: "top center",
			toggleActions: "restart none none reverse",
		};
		gsap.fromTo(
			".paypal-big",
			{
				x: -500,
			},
			{
				x: 0,
				duration: 1.5,
				scrollTrigger: scroll,
			}
		);
		gsap.fromTo(
			".stripe-big",
			{
				x: 500,
			},
			{
				x: 0,
				duration: 1.5,
				scrollTrigger: scroll,
			}
		);
		gsap.fromTo(
			".d-poem",
			{
				y: 100,
				opacity: 0,
			},
			{
				y: 0,
				opacity: 1,
				delay: 1,
				duration: 1.5,
				scrollTrigger: scroll,
			}
		);
		gsap.fromTo(
			".paypal-small",
			{
				x: -1000,
				rotate: 0,
			},
			{
				x: 0,
				rotate: 360,
				duration: 1.5,
				delay: 0.5,
				scrollTrigger: scroll,
			}
		);
		gsap.fromTo(
			".stripe-small",
			{
				x: 1000,
				rotate: 0,
			},
			{
				x: 0,
				rotate: -360,
				duration: 1.5,
				delay: 0.5,
				scrollTrigger: scroll,
			}
		);
	}, []);

	return (
		<div className="year-wrap-slide-2">
			<div className="w-100 d-pt-5 d-pb-5">
				<Row>
					<Col lg={6}>
						<div
							className="position-relative z-index-0 d-mr-10 paypal-big"
							// style={{ padding: "7%" }}
						>
							<div className="position-relative z-index-1">
								<img width="100%" height="100%" src={union3} />
							</div>
							<div
								className="position-absolute z-index-2 h-100 top-0 right-0"
								style={{ padding: "7%" }}
							>
								<div className="bg-white h-100 rounded-circle d-flex justify-content-center align-items-center">
									<b className="d-text-100 d-text-secondary">
										{formated(yearEndData?.paypal)}
									</b>
								</div>
							</div>
							<div className="position-absolute z-index-1 top--5 right--5 w-15 paypal-small">
								<img src={paypal} />
							</div>
							<div
								className="d-flex justify-content-between align-items-center position-absolute z-index-2 top-0 left-0 h-100 w-90"
								style={{ padding: "7%" }}
							>
								<b className="d-text-30 d-text-white">
									Orders synced <br />
									to PayPal
								</b>
								<div
									className="text-center"
									style={{ minWidth: "150px" }}
								>
									{/* <b className="d-text-100 d-text-secondary">
                    {formated(yearEndData?.paypal)}
                  </b> */}
								</div>
							</div>
						</div>
					</Col>
					<Col lg={6}>
						<div
							className="position-relative z-index-0 d-ml-10 stripe-big"
							// style={{ padding: "7%" }}
						>
							<div className="position-relative z-index-1">
								<img width="100%" height="100%" src={union4} />
							</div>
							<div
								className="position-absolute z-index-2 w-100 h-100 top-0 left-0"
								style={{ padding: "7%" }}
							>
								<div className="bg-white h-100 rounded-circle d-flex justify-content-center align-items-center">
									<b className="d-text-100 d-text-violet">
										{formated(yearEndData?.stripe)}
									</b>
								</div>
							</div>
							<div className="position-absolute z-index-1 top--5 left--5 w-15 stripe-small">
								<img src={stripe} />
							</div>

							<div
								className="d-flex justify-content-between align-items-center position-absolute z-index-2 top-0 right-0 h-100 w-90"
								style={{ padding: "7%" }}
							>
								<div
									className="text-center"
									style={{ minWidth: "150px" }}
								>
									{/* <b className="d-text-100 d-text-violet">
                    {formated(yearEndData?.stripe)}
                  </b> */}
								</div>
								{yearEndData?.stripe != 0 ? (
									<b className="d-text-30 d-text-white">
										Orders synced <br />
										to Stripe
									</b>
								) : (
									<a
										href="https://synctrack.gitbook.io/feature-guides/how-to-connect-the-app-with-your-stripe-account-add-tracking-auto-app"
										target="_blank"
										onClick={() => handleClickReview()}
									>
										<b className="d-text-25 d-text-white glow-text">
											Got no orders <br /> synced to
											Stripe?
											<br /> Click to fix!
										</b>
									</a>
								)}
							</div>
						</div>
					</Col>
				</Row>
				<div className="m-auto text-center d-pt-10">
					<span className="d-text-40 d-text-white d-poem">
						Stripe is violet, PayPal is blue. Every orders you got,
						Synctrack will come through 😉
					</span>
				</div>
			</div>
		</div>
	);
};

export default Slide2;
